<template>
    <div>
        Logging out
    </div>
</template>

<script>
    import Cookie from '@/services/cookie';

    export default {
        name: 'Logout',

        created() {
            Cookie.deleteToken();
            window.location.href = '/';
        },
    };
</script>
